import { isFunction } from "./index";
/**
 * Find summary of number array.
 * @param {array} values 
 * @param {function} getValue
 */
function sum(values, getValue = undefined){
	if(values.length === 0){
		return 0;
	}
	let total = 0;
	values.forEach(v=>{
		if(isFunction(getValue)){
			total += getValue(v);
		}else{
			total += v;
		}
	});
	return total;
}
/**
 * Calculate compare ratio between 2 value
 * @param {number} base 
 * @param {number} compare 
 */
function increaseRatio(base = 0, compare = 0){
	if(base===0){
		if(compare!==0)
			return -1;
		return 0;
	}else if(compare===0){
		return 1;
	}
	return (base - compare) / (compare ? compare : 1);
}
export default { sum, increaseRatio };


// WEBPACK FOOTER //
// ./src/util/aMath.js